<div>
  <label class="primary-color" >Due to some internal server error, we are unable to proceed now </label>
</div>

<ng-container *maiaPopUpFooter>
  <button maiaButton maiaButtonType="delete"  (click)="this.control.confirm()">Try Again</button>

</ng-container>
